export type EventPriceGroupModel = {
    id: number,
    internetNameFr: string,
    internetNameEn: string
}